// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getVideoProviderListFailed, getVideoProviderListRequested, getVideoProviderListSucceeded } from './select-video-provider.actions';
import { DictionariesService } from '@par/app/core/data-services/dictionaries.service';
import { Store } from '@ngrx/store';
import { selectVideoProviderListResponse } from './select-video-provider.selectors';

@Injectable()
export class SelectVideoProviderEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getVideoProviderListRequested),
      withLatestFrom(this.store.select(selectVideoProviderListResponse)),
      filter(([, response]) => response == null),
      switchMap(() => this.service.getVideoProviderList()
        .pipe(
          map((response) => getVideoProviderListSucceeded({response})),
          catchError(() => of(getVideoProviderListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: DictionariesService,
    private store: Store,
  ) {
  }
}
